var $window = $(window);
var breakPoint = 768;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//SPヘッダーの開閉
import {spHeaderToggle} from "../include/module";
spHeaderToggle();

//ヘッダースクロール
import {headerClass} from "../include/module";
headerClass();

//wp pagenavi
import {pagenaviURL} from "../include/module";
pagenaviURL();

function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$(function () {
  var production = getParam('production');
  var genre = getParam('genre');
  $('.category ul li').each(function () {
    var tagetClass = $(this).attr('class');
    if(tagetClass == production || tagetClass == genre){
      $(this).addClass('current');
    }
  });
  if(!production){
    $('.production ul li.all').addClass('current');
  }
  if(!genre){
    $('.genre ul li.all').addClass('current');
  }
});

const attrRestring = () => {
  $('.category ul li').each(function () {
    var number = $('.category ul li').index(this);
    var tagetString = $(this).children('a').attr('href');
    var reString;
    if($(this).hasClass('all')){
      if ( tagetString.indexOf('?#038;') != -1) {
        var reString = tagetString.replace("#038;", "");
      }else{
        var count = ( tagetString.match( new RegExp( "=", "g" ) ) || [] ).length ;
        if(count >= 2){
          var reString = tagetString.substring(0,tagetString.indexOf("#038;"));
        }
      }
    }else{
      if ( tagetString.indexOf('#038;') != -1) {
        if ( tagetString.indexOf('genre', tagetString.indexOf('genre') + 1) != -1) {
          var reString = tagetString.substring(0,tagetString.indexOf("#038;"));
        }else if ( tagetString.indexOf('production', tagetString.indexOf('production') + 1) != -1) {
          var reString = tagetString.substring(0,tagetString.indexOf("#038;"));
        }else{
          var reString = tagetString.replace("#038;", "&");
        }
      }else{}
    }

    $(this).children('a').attr('href', reString);
  });
};
attrRestring();


// WEBPACK FOOTER //
// ./src/assets/js/products/script.js